import Error from "./Error";
import {withTranslation} from "react-i18next";
import React from "react";

function Error404(props){
    console.log(props);
    return <Error title={props.t("error.404")} goToHome/>;
}

export default withTranslation()(Error404);